var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanedoutPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -905.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_LoanedoutPlayer",
    transform: "translate(30.000000, 608.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Go_arrow",
    opacity: 0.699999988,
    transform: "translate(15.000000, 15.000000) rotate(-360.000000) translate(-15.000000, -15.000000) translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_arrow-forward_2459676",
    transform: "translate(0.800000, 3.200000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3696737,5.4614469 L14.3444449,5.49391571 L14.3203467,5.52148771 L14.3063477,5.53616903 L9.87649931,10.0385647 C9.75382171,10.1635605 9.58714895,10.2335616 9.41361225,10.2333329 C9.28119041,10.2333329 9.1552706,10.192835 9.04979916,10.1212001 C8.94471755,10.0498299 8.85993103,9.94753032 8.80943713,9.82361821 C8.75908349,9.70005029 8.74781059,9.56715145 8.77240524,9.44149886 C8.79703652,9.3156591 8.85763067,9.19711703 8.9508063,9.10241901 L8.9508063,9.10241901 L12.2683349,5.73001694 L0.553741897,5.7308484 C0.373032677,5.7308484 0.209355001,5.65652933 0.0909046098,5.53613908 C-0.0269626225,5.41634154 -0.1,5.2508798 -0.1,5.0680379 C-0.1,4.88519601 -0.0269626225,4.71973427 0.0909046098,4.59993673 C0.209355001,4.47954648 0.373032677,4.40522741 0.553739995,4.40522741 L0.553739995,4.40522741 L12.2683043,4.40500454 L8.95130177,1.03417945 C8.78491696,0.86740747 8.71897983,0.622820458 8.77894788,0.393178484 C8.80895349,0.278274838 8.86814259,0.175977912 8.94804469,0.0947557687 C9.02823706,0.0132385701 9.1292866,-0.0470579292 9.2427276,-0.077677279 C9.35637805,-0.108353163 9.47375772,-0.106901644 9.58336971,-0.0765095866 C9.69277499,-0.0461748459 9.79445835,0.013001891 9.87638852,0.0974208862 L9.87638852,0.0974208862 L14.2715375,4.5619217 C14.3704815,4.6478636 14.4436757,4.76340981 14.4782118,4.89566247 C14.5151096,5.03695893 14.5043709,5.18395726 14.447385,5.32458175 L14.447385,5.32458175 L14.4349871,5.34722212 L14.421932,5.37784013 L14.4141862,5.38948116 L14.3925858,5.42783646 L14.35,5.493 L14.3696737,5.4614469 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanedoutPlayer);
export default __webpack_public_path__ + "static/media/loanedout-player.ded3b54cadbeb14cfa9ede03b55a60b9.svg";
export { ForwardRef as ReactComponent };